import { Component, inject, Input } from '@angular/core';
import { WhiteboardDrawingsService, WhiteboardEventsService } from '@lemberger/whiteboards';
import { WhiteboardDrawingsListItemComponent } from '../whiteboard-drawings-list-item.component';
import { ModalableWhiteboardVideo } from '../../../../../../models/modalable-whiteboard-video';
import { ModalService } from '../../../../../../services/modal.service';
import { WhiteboardDrawing } from '../../../../../../models/whiteboard-drawing';
import { BookviewerWhiteboardDrawingsService } from '../../../../../../services/bookviewer-whiteboard-drawings.service';
import { NgClass, NgStyle } from '@angular/common';
import { TechnicalFeature } from '@lemberger/lemberger-am';
import { CrudService } from '../../../../../../services/crud.service';

@Component({
    selector: 'app-whiteboard-drawings-list-item-context-menu',
    templateUrl: './whiteboard-drawings-list-item-context-menu.component.html',
    styleUrls: ['./whiteboard-drawings-list-item-context-menu.component.scss'],
    imports: [
        NgClass,
        NgStyle
    ],
    standalone: true
})
export class WhiteboardDrawingsListItemContextMenuComponent {

    @Input() whiteboard: WhiteboardDrawing;
    private crudService = inject(CrudService);

    colors = ['#ffffff', '#ffb800', '#ffb0ca', '#acd8ff', '#c0ed72', '#808ea4'];
    icons = ['fa-link', 'fa-map-pin', 'fa-chalkboard', 'fa-play', 'fa-video'];
    color = 'brown';
    icon = '';
    status = false;

    constructor(private bookviewerWhiteboardService: BookviewerWhiteboardDrawingsService,
                private whiteboardService: WhiteboardDrawingsService,
                private whiteboardEventsService: WhiteboardEventsService,
                private changeColorForWhiteboard: WhiteboardDrawingsListItemComponent,
                private modalService: ModalService) {
    }

    delete(): void {
        this.bookviewerWhiteboardService.deleteWhiteboard(this.whiteboard.book_id, this.whiteboard).subscribe(
            () => {
                this.whiteboardService.whiteboardEvents.next({
                    whiteboardDrawing: this.whiteboard,
                    eventType: 'deleted'
                });
            }
        );
    }

    playVideo(): void {
        const modalable = new ModalableWhiteboardVideo();
        Object.assign(modalable, this.whiteboard);
        this.modalService.openModal(modalable);

        this.crudService.logDirect(TechnicalFeature.Whiteboard);
    }

    addToPage(): void {
        this.crudService.logDirect(TechnicalFeature.Whiteboard);

        this.whiteboardEventsService.emitLinkWhiteboardToPage(this.whiteboard);
    }

    moveToPage(): void {
        this.crudService.logDirect(TechnicalFeature.Whiteboard);

        this.whiteboardEventsService.emitTurnToPageWithIndex(this.whiteboard.page_id);
        setTimeout(() => {
            this.scaleWhiteboardIcon();
        }, 500);
    }

    scaleWhiteboardIcon(): void {
        const element = document.getElementById(`whiteboard-rect-${this.whiteboard.id}`).getElementsByTagName('span')[0];
        element.style.transform = 'scale(2)';

        setTimeout(() => {
            element.style.transform = '';
        }, 1000);
    }

    removePage(): void {
        this.whiteboard.page_id = null;
        this.whiteboard.page = null;
        this.whiteboard.position = { x: null, y: null, w: null, h: null, moveX: null, moveY: null };
        this.bookviewerWhiteboardService.updateWhiteboard(this.whiteboard.book_id, this.whiteboard).subscribe();
    }

    changeColor(color): void {
        this.changeColorForWhiteboard.setColor(color);
    }

    changeIcon(icon): void {
        this.changeColorForWhiteboard.setIcon(icon);
    }
}
